module.exports = __webpack_public_path__ + "img/competencies_rd_swiper_01.e223d77c.jpg";